module.exports = __webpack_public_path__ + "static/media/left.6e01e090.png";